import controller from './site-lookup.controller';

const SiteLookupComponent = {
    controller,
    template: `
        <breadcrumbs
            crumbs="[]"
            current-page-name="'Site ID Lookup'">
        </breadcrumbs>
        
        <div class="container data-list site-lookup-list">
            
            <page-title
                title="'Site ID Lookup'"
                icon="'fa-building'">
            </page-title>
            
            <div class="list-header-wrapper">
            
                <list-header
                    headers="$ctrl.headers"
                    on-column-click="$ctrl.sortList(sortColumn)"
                    sort-index="$ctrl.sortIndex"
                    sort-prop-display="$ctrl.sortPropDisplay">
                </list-header>
                
                <div class="filter-bar">
                    
                    <div class="filter-input-wrapper md">

                        <input
                            ng-model="$ctrl.search.location_site_id"
                            class="form-control"
                            placeholder="filter..."
                            type="text"
                            data-tid-search-location-site-id
                            numbers-only>

                    </div>

                    <div class="filter-input-wrapper md">
        
                        <input
                            ng-model="$ctrl.search.name"
                            class="form-control"
                            number-maxlength="7"
                            placeholder="filter..."
                            data-tid-search-name
                            type="text">
        
                    </div>

                    <div class="filter-input-wrapper md">
        
                        <input
                            ng-model="$ctrl.search.client_name"
                            class="form-control"
                            number-maxlength="7"
                            placeholder="filter..."
                            data-tid-search-client-name
                            type="text">
        
                    </div>

                    <div class="filter-input-wrapper md">
        
                        <input
                            ng-model="$ctrl.search.client_site_id"
                            class="form-control"
                            number-maxlength="7"
                            placeholder="filter..."
                            type="text"
                            data-tid-search-client-site-id
                            numbers-only>
        
                    </div>
                    
                     <div class="filter-input-wrapper md">
        
                        <input
                            ng-model="$ctrl.search.state"
                            class="form-control"
                            number-maxlength="7"
                            placeholder="filter..."
                            type="text"
                            data-tid-search-state>
        
                    </div>                   

                     <div class="filter-input-wrapper md">
        
                        <input
                            ng-model="$ctrl.search.city"
                            class="form-control"
                            number-maxlength="7"
                            placeholder="filter..."
                            type="text"
                            data-tid-search-city>
        
                    </div>   

                    <button
                        ng-click="$ctrl.resetFilters()"
                        class="btn btn-warning filter-reset-button"
                        title="reset filters">
        
                        Reset<br>
                        Filters
        
                    </button>

                </div>
                    
            </div>

            <site-lookup-row 
                ng-repeat="site in siteList = ($ctrl.siteList
                   | filter: $ctrl.search
                   | orderBy:$ctrl.sortProp:$ctrl.isReverseSort)"
                ng-class-odd="'odd-row'"
                site="site">    
            </site-lookup-row>
            
        </div>
    `,
};

export default SiteLookupComponent;



// WEBPACK FOOTER //
// ./app/components/site-lookup/site-lookup.component.js